// The HTTP method + path for each API endpoint, in one place.
//
// This is plain data (no TypeBox import) so it is safe to bundle into the
// browser. The server (src/index.ts) registers its routes at these exact paths
// and the typed client (src/client/apiClient.ts) fetches them, so neither can
// use a path or method the other doesn't. The `satisfies` clause forces the key
// set to stay in lockstep with RouteTypeMap in ./schemas.ts.

import type { RouteTypeMap } from './schemas';

export interface RouteInfo {
  method: 'GET' | 'POST';
  path: string;
}

export const apiRoutes = {
  sendVerification: { method: 'POST', path: '/send-verification' },
  checkVerification: { method: 'POST', path: '/check-verification' },
  loginPassword: { method: 'POST', path: '/login-password' },
  setPassword: { method: 'POST', path: '/set-password' },
  updateName: { method: 'POST', path: '/api/update-name' },
  getAvailableSlots: { method: 'GET', path: '/available-slots' },
  bookSlot: { method: 'POST', path: '/book-slot' },
  bookingDensity: { method: 'GET', path: '/api/booking-density' },
  bookCustomRange: { method: 'POST', path: '/api/book-custom-range' },
  editBooking: { method: 'POST', path: '/api/edit-booking' },
  removeBookingGuest: { method: 'POST', path: '/api/remove-booking-guest' },
  setBookingRoomPreference: { method: 'POST', path: '/api/booking-room-preference' },
} satisfies Record<keyof RouteTypeMap, RouteInfo>;
